// extracted by mini-css-extract-plugin
export default {"gripHandle":"zbPnwdYUJtZSlFPnNcSQ","item":"SiwkQBBMv633I_lvcs5J"};